import { cancelAllPendingAckTasks } from '@/store/listeners/poc/pendingAckCoordinator';
import type { AppServices } from '@/types/services.types';

export function registerBeforeUnloadHandler(getServices: () => AppServices): void {
  window.addEventListener('beforeunload', () => {
    cancelAllPendingAckTasks();
    void getServices().pocServices.p2pStackManagerService.shutdownAllStacks();
  });
}
